export const ActionType = {
  GetList: Symbol("GetMaterialList"),
  Update: Symbol("UpdateMaterial"),
  UpdateList: Symbol("UpdateMaterialList"),
  UpdateStatus: Symbol("UpdateMaterialStatus"),
};
